import { SuppliersTableColumnKey } from '../types/suppliersTableColumnKey'

export const suppliersTableColumnHeaderLocaleKeys: Record<SuppliersTableColumnKey, string> = {
  actions: 'actions',
  country: 'contacts.table.headers.country',
  email: 'contacts.table.headers.email',
  name: 'contacts.table.headers.name',
  phone: 'contacts.table.headers.phone',
}
